import React, { useState } from 'react';
import classes from "./checkout.module.css";
import { sixYardAxios } from '../../../sixYardAxios';
// import InputField from "../../containers/inputField/inputField";
import DoubleArrow from "../../../assets/images/red-arrow.png";
import PromptMessage from '../../containers/promptMessage/promptMessage';

const Checkout = (props) => {
    const [showPromptMessage, setShowPromptMessage] = useState(false);
    const [loyaltyPointsUsed, setLoyaltyPointsUsed] = useState(0);
    const [partialValue, setPartialValue] = useState(10);
    const [loyalty, setLoyalty] = useState(0);
    const [checkLoyaltyEnteredAmount, setCheckLoyaltyEnteredAmount] = useState(null);
    const [error, setError] = useState(null);
    const [totalAmount, setTotalAmount] = useState(props.amount);
    const [paymentType, setPaymentType] = useState("partial");
    const [loading, setLoading] = useState(null);
    // const [controls, setControls] = useState({
    //     cardNumber: {
    //         elementType: "input",
    //         elementConfig: {
    //             type: "number",
    //             placeholder: "XXXX - XXXX - XXXX - XXXX",
    //         },
    //         value: "",
    //         validation: {
    //             required: true,
    //         },
    //         label: "Card Number",
    //         valid: false,
    //         touched: false
    //     },
    //     expiryDate: {
    //         elementType: "input",
    //         elementConfig: {
    //             type: "number",
    //             placeholder: "MM/YY",
    //         },
    //         value: "",
    //         validation: {
    //             required: true,
    //         },
    //         label: "Expiry Date",
    //         valid: false,
    //         touched: false
    //     },

    //     ccv: {
    //         elementType: "input",
    //         elementConfig: {
    //             type: "password",
    //             placeholder: "***",
    //         },
    //         value: "",
    //         validation: {
    //             required: true,
    //             minLength: 6,
    //             maxLength: 32,
    //         },
    //         label: "CCV",
    //         valid: false,
    //         touched: false
    //     }
    // });
    // const formElementsArray = [];
    // for (let key in controls) {
    //     formElementsArray.push({
    //         id: key,
    //         config: controls[key]
    //     });
    // }
    // const form = formElementsArray.map((formElement, i) => (
    //     <div key={i} className={classes.FormGroup}>
    //         <InputField
    //             key={formElement.id}
    //             elementType={formElement.config.elementType}
    //             elementConfig={formElement.config.elementConfig}
    //             value={formElement.config.value}
    //             invalid={!formElement.config.valid}
    //             shouldValidate={formElement.config.validation}
    //             touched={formElement.config.touched}
    //             withRemove={false}
    //             label={formElement.config.label}
    //             changed={event => inputChangedHandler(event, formElement.id)}
    //         />
    //     </div>
    // ));
    // const checkValidity = ((value, rules) => {
    //     let isValid = true;
    //     if (!rules) {
    //         return true;
    //     }

    //     if (rules.required) {
    //         value = typeof value === 'string' ? value.trim() : value;
    //         isValid = value !== "" && isValid;
    //     }

    //     if (rules.minLength) {
    //         isValid = value?.length >= rules.minLength && isValid;
    //     }

    //     if (rules.maxLength) {
    //         isValid = value?.length <= rules.maxLength && isValid;
    //     }

    //     if (rules.isEmail) {
    //         const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
    //         isValid = pattern.test(value) && isValid;
    //     }

    //     if (rules.isNumeric) {
    //         const pattern = /^\d+$/;
    //         isValid = pattern.test(value) && isValid;
    //     }

    //     return isValid;
    // })
    // const inputChangedHandler = (event, controlName) => {
    //     const updatedControls = {
    //         ...controls,
    //         [controlName]: {
    //             ...controls[controlName],
    //             value: event.target.value,
    //             valid: checkValidity(
    //                 event.target.value,
    //                 controls[controlName].validation
    //             ),
    //             touched: true
    //         }
    //     };
    //     setControls(updatedControls);
    // };
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.tournamentId,
                amount: paymentType === "full" ? totalAmount : partialValue,
                payment_type: paymentType,
                loyalty_points_used: loyaltyPointsUsed,
                "customer_name": "",
                "customer_email": ""
            }
            const response = await sixYardAxios.post('/payments/initiate/tournament', formData);
            if (response.data.data) {
                const redirectUrl = response.data.data.redirect_url;
                localStorage.removeItem("CustomTournament");
                props.setShowCheckout(false);
                window.scrollTo({ top: 0, behavior: 'smooth' });
                setShowPromptMessage(true);
                redirectUrl != null && window.open(redirectUrl, '_blank');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const calculateLoyaltyAmount = (e) => {
        if (e.target.value <= props.loyaltyPoints) {
            setLoyalty(e.target.value);
        }
        else {
            setCheckLoyaltyEnteredAmount("The amount you enter greater than your points");
        }
    }
    const closeLoyaltyIssue = () => {
        setCheckLoyaltyEnteredAmount(null)
        setLoyalty("");
    }
    const loyaltySubmitHandler = (e) => {
        e.preventDefault();
        setLoyaltyPointsUsed(loyalty)
        setTotalAmount(props.amount - (loyalty))
    }
    return (
        <div className={classes.Container}>
            <div className={classes.Path}><span onClick={() => props.setShowCheckout(false)}>Create Tournament</span> / Checkout</div>
            <h1>Checkout</h1>
            <div className={classes.Content}>
                <div className={classes.BookingSummery}>
                    <h3>Tournament Summary</h3>
                    <div className={classes.info}>
                        <p>{props.dates[0]} to {props.dates[(props.dates.length) - 1]}</p>
                        {/* <p>Al Madina Al Monawara St,</p> */}
                    </div>
                    <div>
                        You have <span className={classes.money}>{props.loyaltyPoints} JD </span>
                        from loyalty program, enter the amount you desire to use.
                    </div>
                    <form onSubmit={(e) => loyaltySubmitHandler(e)}>
                        <label>Amount</label><br />
                        <input placeholder='Enter amount' value={loyalty}
                            onChange={(e) => calculateLoyaltyAmount(e)} />
                        <button type='submit'>Calculate</button>
                    </form>
                </div>
                <div className={classes.PaymentSummery}>
                    <h3>Payment Summary</h3>
                    <div>
                        <span><span className={classes.Quantity}>{props.dates?.length > 0 && props.dates?.length} X </span>
                            Tournament Day</span>
                        <span>{props.amount} JD</span>
                    </div>
                    {props.selectedServices.length > 0 && props.selectedServices.map((service,i)=>
                    <div key={i}>
                        <span>{service.name}</span>
                        <span>{service.price} JD</span>
                    </div>)}
                    <div className={classes.LoyaltyPoints}>
                        <span>Loyalty Program Points</span>
                        <span className={classes.Zero}>{loyaltyPointsUsed === "" ? 0 : loyaltyPointsUsed} JD</span>
                    </div>
                    <div className={classes.Total}>
                        <span>Total</span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <h3>Payment Amount</h3>
                    <div className={classes.Note}>
                        <div className={classes.NoteIcon}>i</div>
                        <div>You can pay down payment or full amount  </div>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input type="radio" checked={paymentType === "partial"} value="partial"
                                onChange={() => setPaymentType("partial")} />
                            <label className={classes.Label}>Down Payment</label>
                        </span>
                        <span>{partialValue} JD</span>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input type="radio" checked={paymentType === "full"} value="full"
                                onChange={() => setPaymentType("full")} />
                            <label className={classes.Label}>Full Amount</label>
                        </span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    {/* <h3>Card Details</h3> */}
                    <form className={classes.FormContainer} onSubmit={(e) => submitHandler(e)}>
                        {/* {form} */}
                        <div className={classes.Buttons}>
                            <button onClick={() => props.setShowCheckout(false)}>
                                <img
                                    src={DoubleArrow}
                                    alt=""
                                    className={classes.Icon}
                                /> BACK
                            </button>
                            <button type="submit">
                                CHECKOUT
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {showPromptMessage && <PromptMessage status='CONGRATULATIONS' message='Your booking is confirmed'
                button='CLOSE' click={() => setShowPromptMessage(false)} successMessage />}
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
            {checkLoyaltyEnteredAmount && <PromptMessage message={checkLoyaltyEnteredAmount} status='Oops' button='CLOSE' click={closeLoyaltyIssue} />}
        </div>
    )
}
export default Checkout;